<template>
  <IQOS
    :title="$t('waiter_schedule.title')"
    required
    enabled
  >
    <BaseTabSwitcher :value="is_active" @input="changeActive" class="mt-16 w-100" cssWidth="100%" size="md" :tabs="[
      {
        text: $t('waiter_schedule.tab_always'),
        value: false
      },
      {
        text: $t('waiter_schedule.tab_schedule'),
        value: true
      }
    ]"/>
    <div v-if="is_active">
      <p class="iqos-comment qrw-label-sm mt-16 bold">
        {{ $t('waiter_schedule.start_date')}}
      </p>
      <div class="mt-8 w-100">
        <v-date-picker 
          class="schedule-picker" 
          locale="uk" 
          v-model="cache_date"/>
      </div>
      <BaseDivider color="v1-grey-4" class="mt-16"/>
      <div
        class="mt-16"
        v-for="(day, index) in waiter.schedule"
        :key="index"
      >
        <p class="iqos-comment qrw-paragraph-md">
          {{ $tc('waiter_schedule.day_noun', index+1)}}
        </p>
        <div class="day-row mt-8">
          <div class="w-100">
            <BaseSelect
              fullWidth
              class="w-100"
              :value="waiter.schedule[index].workday"
              @input="(v) => changeWorkday(index, v)"
            >
              <option :value="false">
                {{ $t('waiter_schedule.freeday')}}
              </option>
              <option :value="true">
                {{ $t('waiter_schedule.workday')}}
              </option>
            </BaseSelect>
          </div>
          <div>
            <BaseButton class="ml-8" color="v1-grey-10" icon="trash" variant="secondary" @click="removeDay(index)" size="md"/>
          </div>
        </div>
        <BaseDivider color="v1-grey-4" class="mb-16 mt-16"/>
      </div>
      <div class="container-box">
        <BaseButton
          class="w-100"
          variant="secondary"
          color="v1-grey-10"
          size="md"
          @click="addDay"
          v-if="waiter.schedule && waiter.schedule.length < 30"
        >
          + {{ $t('waiter_schedule.add_btn')}}
        </BaseButton>
      </div>
      <p class="iqos-comment qrw-paragraph-md mt-16">
        {{ $t('waiter_schedule.desc_on')}}
      </p>
    </div>
    <!-- <p class="comment c-gray pt-0" v-else>
      {{ $t('waiter_schedule.desc_off')}}
    </p> -->
  </IQOS>
</template>
<script>
import IQOS from "@/components/IQOS.vue";
import BlackInput from "@/components/BlackInput.vue";
import BlackSelect from "@/components/BlackSelect.vue";
import DashboardButton from "@/components/DashboardButton.vue";
import IQOSToggle from "@/components/IQOSToggle.vue";

import moment from 'moment'

export default {
  data() {
    return {
      is_active: false, 
    };
  },
  props: {
    waiter: Object,
  },
  mounted() {
    this.is_active = !!this.waiter.schedule.length;
  },
  methods: {
    addDay() {
      if (!this.waiter.schedule) {
        this.waiter.schedule = [];
      }

      this.waiter.schedule.push({
        workday: false,
      });
      this.save();
    },
    save() {
      this.$emit("saved", this.waiter);
    },
    removeDay(idx) {
      this.waiter.schedule.splice(idx, 1);
      this.save();
    },
    changeWorkday(idx, v) {
      this.$set(this.waiter.schedule[idx], "workday", v);
      this.save();
    },
    changeActive(v) {
      if (v) {
        this.is_active = true;
        this.waiter.schedule = [];
      } else {
        this.is_active = false;
        this.waiter.schedule = [];
        this.save();
      }
    },
  },
  computed: {
    cache_date: {
      get() {
        return moment(this.waiter.schedule_start_date).toDate();
      },
      set(v) {
        console.log(v);
        this.$set(this.waiter, 'schedule_start_date', moment(v).toDate());
        this.save();
      }
    }
  },
  components: {
    IQOS,
    BlackInput,
    DashboardButton,
    BlackSelect,
    IQOSToggle,
  },
};
</script>
<style scoped>
.day-row {
  display: flex;
}
</style>


<style>
.schedule-picker .vc-text-base {
  padding: 0.5vh 1vh;
  box-sizing: border-box;
}
</style>